import { View, Text, Button, Flex, Spinner, List } from '@smarterservices/smarter-ui';

/**
 * IntroContent — Displays instructions for using remote control and a start button.
 *
 * Shown when connected to a live session but no remote control session exists yet.
 * Walks the reviewer through the steps to assist a test taker with their password.
 *
 * @param {Object} props
 * @param {Function} props.onStart - Callback to initiate a remote control session
 * @param {boolean} props.isStarting - Whether a start attempt is currently in progress
 * @param {string|null} props.error - Error message from a failed start attempt, or null
 * @returns {JSX.Element}
 */
function IntroContent({ onStart, isStarting, error }) {
  return (
    <>
      <View as="div" margin="none none small none" padding="none large">
        <Text>
          Remote control allows you to interact with the test taker's screen in real time.
          This is primarily used to input the exam password on behalf of the test taker.
        </Text>
        <View as="div" margin="small none none none">
          <Text weight="bold">
            To start assist the test taker with their password follow these steps:
          </Text>
          <List as="ol" margin="medium">
            <List.Item>Ask the user to place their cursor in the password field.</List.Item>
            <List.Item>Click the Start Remote Control button below.</List.Item>
            <List.Item>You will see a visual of their screen that you can interact with. Additioanlly, both the unique password and the actual exam password will be provided for easy access.</List.Item>
            <List.Item>When you are done, click the X in the upper right of the remote control dialog to disconnect from remote control.</List.Item>
          </List>
        </View>
        <Text />
        {error && (
          <View as="div" margin="small none none none">
            <Text size="small" color="danger">{error}</Text>
          </View>
        )}
      </View>
      <View as="div" margin="small none none none">
        <Button
          color="success"
          onClick={onStart}
          interaction={isStarting ? 'disabled' : 'enabled'}
        >
          {isStarting ? (
            <Flex alignItems="center" gap="x-small">
              <Spinner size="x-small" renderTitle="Starting" />
              <Text size="small">Starting...</Text>
            </Flex>
          ) : (
            'Start Remote Control'
          )}
        </Button>
      </View>
    </>
  );
}

export default IntroContent;
